'use client';

import { IcArrowRight, Typography } from '@musinsa/mds';

interface EarningsBoostItemProps {
  icon: React.ReactNode;
  title: string;
  titleLabel?: React.ReactNode;
  text: string;
  rightText?: string;
  onClick?: () => void;
  className?: string;
}

export const EarningsBoostItem = ({
  icon,
  text,
  title,
  titleLabel,
  rightText,
  onClick,
  className,
}: EarningsBoostItemProps) => (
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events
  <div role="button" tabIndex={0} onClick={onClick} className={className}>
    {/* SID-4418: 나의 활동 관리 링크 행 세로 패딩 py-3(12) → py-8(8). 행 높이 64px(8+48+8) 정렬 */}
    <div className="flex items-center gap-12 py-[8px]!">
      <div className="flex-shrink-0">{icon}</div>
      <div className="flex-1 flex flex-col gap-0.5">
        <div className="flex items-center gap-1">
          <Typography variant="body14pxMed">{title}</Typography>
          {titleLabel}
        </div>
        <Typography variant="body13pxReg" colorScheme="gray-600">
          {text}
        </Typography>
      </div>

      <div className="flex-shrink-0 flex items-center gap-2">
        {rightText && (
          <Typography variant="body13pxSemi" colorScheme="gray-700">
            {rightText}
          </Typography>
        )}
        <IcArrowRight width={16} height={16} strokeColor="gray-500" />
      </div>
    </div>
  </div>
);
